// Share initialization across simultaneous picker/paste events, scoped to the UI generation.
export const createAttachmentSession = () => {
  const pending = new Map();
  return async (key, conversationId, create) => {
    if (conversationId) return { id: conversationId };
    if (!pending.has(key)) {
      const promise = Promise.resolve().then(create);
      pending.set(key, promise);
      promise.finally(() => {
        if (pending.get(key) === promise) pending.delete(key);
      }).catch(() => {});
    }
    return pending.get(key);
  };
};
